import Constant from '../const';
import moment from 'moment-timezone';

export default {
  methods: {
    pdfTextPrint(doc, text, y, mode = 'center', offset = 0, options) {
      const textWidth =
        (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let textOffset = 0;
      if (mode === 'center') {
        textOffset = (doc.internal.pageSize.width - textWidth) / 2 + offset;
      }
      if (mode === 'halfCenterStart') {
        textOffset = (doc.internal.pageSize.width - textWidth) / 4 + offset;
      }
      if (mode === 'halfCenterEnd') {
        textOffset = (doc.internal.pageSize.width - textWidth - offset) * 0.75;
      } else if (mode === 'right') {
        textOffset = doc.internal.pageSize.width - textWidth - offset;
      } else if (mode === 'left') {
        textOffset += offset;
      }
      doc.text(text, textOffset, y, options);
    },
    printDocument(doc, data) {
      if (data) {
        doc.setProperties({
          title: `${data?.docName}_${data?.rmNumber}_${moment().format(
            'DD-MM-YYYY',
          )}`,
        });
      }
      doc.autoPrint({ variant: 'non-conform' });
      const hiddFrame = document.createElement('iframe');
      hiddFrame.style.position = 'fixed';
      hiddFrame.style.width = '1px';
      hiddFrame.style.height = '1px';
      hiddFrame.style.opacity = '0.01';
      var userAgent = navigator.userAgent;
      if (
        userAgent.match(/iPad/i) ||
        userAgent.match(/iPhone/i) ||
        userAgent.match(/Android/i)
      ) {
        doc.save(
          `${data?.docName}_${data?.rmNumber}_${moment().format(
            'DD-MM-YYYY',
          )}.pdf`,
        );
      }
      const isSafari = /^((?!chrome|android).)*safari/i.test(
        window.navigator.userAgent,
      );
      if (isSafari) {
        // fallback in safari
        hiddFrame.onload = () => {
          try {
            hiddFrame.contentWindow.document.execCommand('print', false, null);
          } catch (e) {
            hiddFrame.contentWindow.print();
          }
        };
      }
      hiddFrame.src = doc.output('bloburl');
      document.body.appendChild(hiddFrame);
    },
    letterHead(doc, clinic, unit = 'in') {
      let size;
      switch (unit) {
        case 'in':
          size = 1;
          break;
        case 'cm':
          size = 2.54;
          break;
        default:
          size = 1;
          break;
      }
      const letterData = Constant.client.find(
        item => item.name.toLowerCase() === clinic.name.toLowerCase(),
      );
      let width = doc.internal.pageSize.getWidth();
      doc.addImage(
        letterData.letterHead.src,
        'PNG',
        (8.27 - letterData.letterHead.width) / 2,
        letterData.letterHead.height === 1.5 ? 0.1 : 0,
        letterData.letterHead.width * size,
        letterData.letterHead.height * size,
      );
      if (
        letterData.letterHead.src === '/img/kopsurat_jmc_header.3ff7eec3.png'
      ) {
        doc.addImage(
          letterData.letterFoot.src,
          'PNG',
          (8.27 * size - width) / 2,
          5.7 * (size !== 1 ? size + 0.3 : size),
          width + (size !== 1 ? size : 0),
          letterData.letterFoot.height * size,
          '',
          'FAST',
        );
      }
    },
    generateQRCode(
      { letterName, doctor, sip, time = new Date(), doc, x, y },
      QRCode,
      moment,
    ) {
      QRCode.toDataURL(
        [
          `Sesuai dengan ketentuan yang berlaku, ${this.$store.getters.userLoggedIn.clinic.name} mengatur bahwa ${letterName} ini telah ditandatangani secara elektronik oleh:`,
          doctor,
          sip !== null ? `SIP: ${sip}` : null,
          '',
          `Pada tanggal: ${moment(time)
            .locale('id')
            .format('DD MMMM YYYY HH:mm [WIB]')}`,
        ]
          .filter(item => item !== null)
          .join('\n'),
        {
          type: 'image/jpeg',
          width: 170,
          height: 170,
          color: {
            dark: '#000000',
            light: '#ffffff',
          },
        },
        (err, url) => {
          if (err) {
            return err;
          }
          doc.addImage(url, 'JPEG', x, y);
        },
      );
    },
    letterFooter(doc, moment, staff) {
      doc.setFontSize(9);
      doc.setFont('Helvetica', 'normal');
      doc.text(`Petugas: ${staff}`, 0.7, 10.77, {
        align: 'left',
        charSpace: 0,
      });
      doc.text(
        `Dicetak pada: ${moment()
          .locale('id')
          .format('dddd, D MMMM YYYY [pukul] HH.mm [WIB]')}`,
        0.7,
        11.07,
        { align: 'left', charSpace: 0 },
      );
    },
    signatureLayout({
      doc,
      clientRegion,
      createdAt,
      doctorName,
      sip,
      finalY,
      marginX,
    }) {
      const perLine = doc.getTextDimensions(' ').h;
      const addLine = line => perLine * line + 1;

      const alignCenter = (text, addingLine, y, x = 0, maxWidth, align) => {
        doc.text(
          text,
          doc.internal.pageSize.getWidth() / 2 -
            doc.getTextDimensions(text).w / 2 +
            x,
          y || addLine(addingLine),
          { align, charSpace: 0, maxWidth },
        );
      };

      alignCenter(
        `${clientRegion},  ${moment(createdAt || new Date())
          .locale('id')
          .format('DD MMMM YYYY')}`,
        undefined,
        finalY + 0.2,
        marginX + 1,
      );

      const widthContainer = 2.5;
      let tempWidthDoctor = [];
      let fontSize = 10;

      // Split Doctor Name
      let wrappedText = doc.splitTextToSize(doctorName, widthContainer);

      // Adjust font size when more than 2 line
      while (wrappedText.length > 2 && fontSize > 5) {
        fontSize -= 0.5;
        doc.setFontSize(fontSize);
        wrappedText = doc.splitTextToSize(doctorName, widthContainer);
      }

      wrappedText.forEach((line, i) => {
        // Position for x; Negative for left; Positive for right
        const positionX = 2.5;

        const textWidth = doc.getTextWidth(line);
        const textX = 4.9 + (positionX - textWidth) / 2;
        const textY = finalY + 1.2 + i * 0.2;
        doc.text(line, textX, textY);

        tempWidthDoctor.push(textWidth * 0.55);
        // Execute when last line from name
        if (i === wrappedText.length - 1) {
          const sipValue = `SIP : ${this.doctorSip || sip}`;
          const nomorLength = doc.getTextWidth(sipValue) * 0.55;

          const namaLength = Math.max(...tempWidthDoctor);
          const lineLength = Math.max(namaLength, nomorLength);

          // Line Separator
          doc.setLineWidth(0.001);
          doc.setDrawColor(0, 0, 0);
          doc.line(
            6.2 - lineLength,
            finalY + 1.3 + i * 0.2,
            6.1 + lineLength,
            finalY + 1.3 + i * 0.2,
          );

          // Set SIP behaviour
          if (this.doctorSip || sip) {
            doc.setFontSize(10);
            doc.setFont('Helvetica', 'normal');
            alignCenter(sipValue, undefined, finalY + 1.5 + i * 0.2, 2, 'left');
          }
          tempWidthDoctor = [];
        }
      });
    },
  },
};
